import { useState, useRef, useEffect } from "react";
import { Grid, GridColumn, GridToolbar } from "@progress/kendo-react-grid";
import { Button } from "reactstrap";
import { useTranslation } from "react-i18next";
import TemplateService from "../../services/srv-mailTemplate/TemplateService";
import {
  Card,
  CardHeader,
  CardTitle,
  CardBody,
} from "@progress/kendo-react-layout";
import LoadingPanel from "../../components/sys-toolbox/LoadingPanel";

function TemplateList(props) {
  const { t } = useTranslation();
  const gridRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    getData();
  }, [props.isAdded]);

  const getData = () => {
    setLoading(true);
    TemplateService.getList().then((data) => {
      if (data) {
        setData(data);
      }
      setLoading(false);
    });
  };

  const toggleDialogDetail = (e) => {
    props.setTemplateId(e.dataItem.id);
    props.toggleDialogAddTemplate();
  };

  const toggleDialogAdd = (e) => {
    props.setTemplateId(0);
    props.toggleDialogAddTemplate();
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("mail_template_list")}</CardTitle>
      </CardHeader>
      <CardBody>
        {loading && <LoadingPanel />}
        <Grid ref={gridRef} data={data} resizable={true} navigatable={true}>
          <GridToolbar>
            <Button
              color="primary"
              type="button"
              size="sm"
              onClick={toggleDialogAdd}
            >
              <i className="fa fa-plus-circle"></i> {t("add_template")}
            </Button>
          </GridToolbar>
          <GridColumn
            filterable={false}
            width="130px"
            cell={(propColumn) => (
              <td>
                <Button
                  color="primary"
                  type="button"
                  size="sm"
                  onClick={(e) => {
                    toggleDialogDetail(propColumn);
                  }}
                >
                  {t("update")}
                </Button>
              </td>
            )}
          />
          <GridColumn
            field="code"
            title={t("template_code")}
            width="200px"
            filterable={false}
          ></GridColumn>
          <GridColumn
            field="gecerli"
            title={t("valid")}
            width="200px"
            filterable={false}
            cell={(props) => <td>{t(props.dataItem.gecerli.trim())}</td>}
          ></GridColumn>
        </Grid>
      </CardBody>
    </Card>
  );
}

export { TemplateList };
